export enum RegisterMode {
    Create = "Create",
    CreateOrRecover = "CreateOrRecover",
}

export enum LoginDialogMode {
    Login = "Log in",
    Recover = "Recover",
    Register = "Register",
}
